import { configLoader } from '../config/configLoader';
import { createHeaders, handleException, handleResponse } from './util/helper';

let config;

// Hilfsfunktion zum Abrufen der aktuellen Konfiguration
const getConfig = async () => {
  if (!config) config = await configLoader.loadConfig();
  return config;
};

const publicPath = (await getConfig()).PUBLIC_PATH;

export const configService = {
  /**
   * Lädt die Konfigurationsdaten für Zusatzbausteine und Zahlungsintervalle
   */
  async loadConfiguration() {
    try {
      const response = await fetch(`${publicPath}api/products`, {
        method: 'GET',
        headers: createHeaders(),
        credentials: 'include',
      });

      return await handleResponse(response);
    } catch (error) {
      return handleException(error);
    }
  },
};
